<template>
  <div class="BuManagement">
    <AppHeader>部门管理</AppHeader>
    <AppBox class="appBox" id="appBox">
      <el-tabs v-model="activeName" @tab-click="changeTab">
        <el-tab-pane label="部门" name="zero"></el-tab-pane>
        <el-tab-pane label="场景" name="first"></el-tab-pane>
      </el-tabs>
      <template v-if="activeName === 'zero'">
        <BuMenList :maxHeight="maxHeight"></BuMenList>
      </template>
      <template v-if="activeName === 'first'">
        <LeiBieList :maxHeight="maxHeight"></LeiBieList>
      </template>
    </AppBox>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import BuMenList from "@/pages/BuManagement/BuMenList.vue";
import LeiBieList from "@/pages/BuManagement/LeiBieList.vue";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "BuManagement",
  components: {
    LeiBieList,
    BuMenList,
    AppBox,
    AppHeader,
  },
  data() {
    return {
      activeName: "zero",
      maxHeight: null,
    };
  },
  computed: {
    ...mapState("teachingCenter", ["jumpWay", "isBack"]),
    ...mapState("fuzhu", ["buMenList", "leiBieList"]),
  },
  async mounted() {
    this.$nextTick(async () => {
      if (this.isBack) {
        if (this.jumpWay === 0) {
          this.activeName = "zero";
          await this.getBuMenList({
            page: this.buMenList.page,
            size: this.buMenList.size,
          });
        } else {
          this.activeName = "first";
          await this.getLeiBieList({
            page: this.leiBieList.page,
            size: this.leiBieList.size,
          });
        }
      }
      this.setData({key: "isBack", value: false});
    });
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize); // 移除resize事件监听
  },
  methods: {
    ...mapMutations("teachingCenter", ["setData"]),
    ...mapActions("fuzhu", ["getBuMenList", "getLeiBieList"]),
    async changeTab(val) {
      const number = Number(val.index);
      this.setData({key: "jumpWay", value: number});
    },
    handleResize() {
      this.$nextTick(() => {
        const el = document.getElementById("appBox");
        if (el.offsetHeight <= 650) {
          this.maxHeight = el.offsetHeight - el.offsetHeight * 0.56;
        } else {
          this.maxHeight = el.offsetHeight - el.offsetHeight * 0.35;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.BuManagement {
  .appBox {
    height: calc(100vh - 155px);
    min-height: 330px;

    ::v-deep .el-tabs__item {
      color: #ff7918;
      padding: 0 30px 50px 30px;
      margin-left: 30px;
    }

    ::v-deep .el-tabs__item.is-active {
      background-color: #ff7918;
      padding: 0 30px;
      border-radius: 10px;
      color: #ffffff;
      margin-left: 30px;
    }

    ::v-deep .el-tabs__active-bar {
      margin-top: 10px;
      background-color: #e4e7ed;
    }
  }
}
</style>
